import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { enqueueSnackbar } from '../../../../actions/notificationAction';
import { t13s } from '../../../../translationKeys';
import { useInvoiceTableReloadRef } from '../../ui/PayrollInvoices/InvoicesTable/store';
import { assignBankAccountToInvoiceService } from '../services';

export const useAssignBankAccountToInvoice = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const invoiceTableReloadRef = useInvoiceTableReloadRef();

  const { isLoading, isSuccess, data, mutate, error } = useMutation(
    ({ businessId, invoiceId, bankAccountId }) => {
      return assignBankAccountToInvoiceService({
        businessId,
        invoiceId,
        bankAccountId,
      });
    },
    {
      onSuccess: () => {
        dispatch(
          enqueueSnackbar(t13s.NOTIFICATION.BANK_ACOUNT_ASSIGNED_SUCCESS, {
            variant: 'success',
          })
        );
        queryClient.invalidateQueries('fetchTransferAccounts', {
          exact: false,
        });
        invoiceTableReloadRef();
      },
    }
  );

  return {
    isLoading,
    isSuccess,
    error,
    data,
    mutate,
  };
};

export default useAssignBankAccountToInvoice;
